import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import packagesServices from '@src/services/packages.services';

export const getPackagesList = createAsyncThunk(
  'getPackagesList',
  async ({ body, pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      return await packagesServices.getPackagesList({ data: body, pageSize, pageNumber });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updatePackages = createAsyncThunk(
  'updatePackages',
  async (body, { rejectWithValue }) => {
    try {
      return await packagesServices.updatePackages(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const packagesSlice = createSlice({
  name: 'packages',
  initialState: {
    packagesList: [],
    processType: 0,
    isApproved: false,
    tableProperty: {
      currentPage: 1,
      pageSize: 10,
      totalCount: 1,
      totalPages: 1,
    },
  },
  reducers: {
    setProcessType: (state, action) => {
      state.processType = action.payload;
    },
    setIsApproved: (state, action) => {
      state.isApproved = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPackagesList.fulfilled, (state, action) => {
      state.packagesList = action?.payload?.data?.items || [];
      state.tableProperty = action?.payload?.data?.pagedProperty;
    });
    builder.addCase(getPackagesList.rejected, (state, action) => {
      state.packagesList = [];
      state.tableProperty = { currentPage: 1, pageSize: 10, totalCount: 1, totalPages: 1 };
    });
  },
});

export const { setProcessType, setIsApproved } = packagesSlice.actions;
